import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'



export const partcatelogueAction = (page) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.PART_CATELOGUE_LIST+`?page=${page}&page_size=15`
    const options = {
      method: HTTP_METHOD.GET,
      headers: getHeaders(),
      url
    };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_PART_CATELOGUE_LIST, payload: resp?.data })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }
  

  export const EditpartcatelogueAction = (id) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.EDIT_PART_CATELOGUE_LIST+"/"+id
    const options = {
      method: HTTP_METHOD.GET,
      headers: getHeaders(),
      url
    };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_EDIT_PART_CATELOGUE_LIST, payload: resp?.data })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }
  
  
  export const VehicleCategoryAction = (id) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.VEHICLE_CATEGORY_LIST
    const options = {
      method: HTTP_METHOD.GET,
      headers: getHeaders(),
      url
    };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_VEHCILE_CATEGORY_LIST, payload: resp?.data })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }

  // CREATE CATELOGUE POST API

  export const createcatalogueAction = (params = {}) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.CREATE_CATALOGE
    const options = {
      method: 'POST',
      headers: getHeadersformdata(),
      url,
      ...(params && { data: params })
    };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_CREATE_CATALOGE, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      errorHandler(error)
    })
  }

    // UPDATE CATELOGUE POST API

    export const updatecatalogueAction = (id, params = {}) => dispatch => {
      const API_URL = localStorage.getItem('countryBackendUrl')
      const url = API_URL + Url.UPDATE_CATALOGE+"/"+id
      const options = {
        method: 'POST',
        headers: getHeadersformdata(),
        url,
        ...(params && { data: params })
      };
      return axiosInstance(options).then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          dispatch({ type: types.PUT_UPDATE_CATALOGE, payload: resp })
          return resp
        } else { return null }
      }).catch(error => {
        errorHandler(error)
      })
    }

    
 // partlist  Page data Action
  export const partCateloguePageValue = (params = {}) => dispatch => {
    dispatch({ type: types.PART_CATALOGUE_PAGE_INPUT, payload: params ? params  : null })
  }
  